export interface LoginRouteSearch {
  returnTo?: string;
}

export const DEFAULT_LOGIN_RETURN_TO = "/dashboard";
const LOGIN_RETURN_TO_BASE_URL = "https://login.glider.invalid";

export function normalizeLoginReturnTo(value: unknown): string | undefined {
  if (typeof value !== "string") {
    return undefined;
  }

  const trimmed = value.trim();
  if (!trimmed.startsWith("/")) {
    return undefined;
  }

  try {
    const returnUrl = new URL(trimmed, LOGIN_RETURN_TO_BASE_URL);
    if (
      returnUrl.origin !== LOGIN_RETURN_TO_BASE_URL ||
      returnUrl.pathname === "/login" ||
      returnUrl.pathname.startsWith("/login/")
    ) {
      return undefined;
    }

    return `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`;
  } catch {
    return undefined;
  }
}

export function normalizeLoginSearch(
  raw: Record<string, unknown>,
): LoginRouteSearch {
  const returnTo = normalizeLoginReturnTo(raw.returnTo);
  return returnTo ? { returnTo } : {};
}
